import React from 'react'

function TextInput({
  placeholder,
  value,
  onChange,
  label,
  ariaLabel,
  onKeyPress,
  inputClass,
  labelClass,
  id,
  textArea,
  rows,
  cols,
  disabled
}) {  
  return (
    <>
        <label id={id} className={`font-semibold text-secondary my-auto ${labelClass}`}>{label}</label>
        {!textArea && <input aria-label={ariaLabel} type="text" value={value} onChange={onChange} onKeyPress={onKeyPress} placeholder={placeholder} className={`bg-light focus:outline-none rounded text-sm leading-none text-secondary py-3 w-full pl-3 mt-2 ${inputClass}`} disabled={disabled}/>}
        {textArea && <textarea rows={rows} cols={cols} aria-label={ariaLabel} type="text" value={value} onChange={onChange} onKeyPress={onKeyPress} placeholder={placeholder} className={`bg-light focus:outline-none rounded text-sm leading-none text-secondary py-3 w-full pl-3 mt-2 ${inputClass}`} disabled={disabled}/>}
    </>
  )
}

export default TextInput
